import React from 'react';
import classes from "./RadioButton.module.css";

const RadioButton = ({ children, selectedValue, onChange, ...restProps }) => {
  const isChecked = selectedValue === restProps.value;

  return (
    <div className={classes["radio"]}>
      <input
        type="radio"
        checked={isChecked}
        onChange={onChange}
        {...restProps}
        className={classes["radio__input"]}
      />
      <label htmlFor={restProps.id} className={classes["radio__label"]}>
        {children}
      </label>
    </div>
  );
};

export default RadioButton;
